// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions[data-v-0e28a35a]{justify-content:flex-start}.widget-info-block-card[data-v-0e28a35a]{width:300px;margin:0 auto 10px}.widget-info-block[data-v-0e28a35a]{display:flex}.logo-small[data-v-0e28a35a]{width:52px;height:52px;border-radius:50%;margin-right:10px}", ""]);
// Exports
module.exports = exports;
